import { IconType } from "../../../common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { Button, type ButtonProps } from "~/common/components/Button/Button";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

type AddToCartButtonProps = {
  actionVariant?: "cart" | "quote" | "salesman";
} & Omit<ButtonProps, "children">;
export const AddToCartButtonBase = (props: AddToCartButtonProps) => {
  const { t } = useTranslation();
  const { actionVariant = "cart", ...rest } = props;

  let icon;
  let label;
  if (actionVariant === "cart") {
    icon = IconType.Cart;
    label = t("addToCartPopup.add.submitBtn");
  } else if (actionVariant === "quote") {
    icon = IconType.FileList;
    label = t("cartPage.btn.quote");
  } else {
    icon = IconType.Cart;
    label = t("basket.addToQuote");
  }

  return (
    <Button fullWidth={true} startIcon={<DefaultButtonIcon type={icon} />} data-test-id={"btn-add-to-cart"} {...rest}>
      {label}
    </Button>
  );
};
